// Collapsible total of materials across every Converted stop on the route
// (Accepted quotes matching each stop's address). Per-stop items live on the
// stop list; this is just the roll-up for the route header.
import React, { useState } from 'react';
import styled from 'styled-components';
import { FaBoxes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { getUnitInfo } from '../../estimates/ServiceModal';
import { formatCurrency } from '../../../utils/utils';
import { formatQty } from '../utils';

const Wrap = styled.div`
  margin-top: ${p => p.theme.spacing(2)}; border-top: 1px solid ${p => p.theme.colors.inputGray}22; padding-top: ${p => p.theme.spacing(1.5)};
`;
const Toggle = styled.button`
  width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 10px;
  background: transparent; border: none; padding: 0; cursor: pointer; text-align: left;
  color: ${p => p.theme.colors.textPrimary}; font-size: 0.98rem; font-weight: 700;
  .l { display: inline-flex; align-items: center; gap: 8px; } .l svg { color: ${p => p.theme.colors.primary}; }
  .r { display: inline-flex; align-items: center; gap: 10px; color: ${p => p.theme.colors.primary}; }
`;
const Row = styled.div`
  display: flex; justify-content: space-between; gap: 12px; padding: 7px 0; font-size: 0.88rem;
  border-top: 1px solid ${p => p.theme.colors.inputGray}18; color: ${p => p.theme.colors.textPrimary};
  .qty { color: ${p => p.theme.colors.textSecondary}; font-size: 0.8rem; } .price { white-space: nowrap; }
`;
const Muted = styled.div`font-size: 0.85rem; color: ${p => p.theme.colors.textSecondary}; margin-top: 8px;`;
const Err = styled.div`font-size: 0.85rem; color: ${p => p.theme.colors.error}; margin-top: 8px;`;

const RouteMaterialsSummary = ({ materials }) => {
  const [open, setOpen] = useState(true);
  const { stopCards, summary, grandTotal, loading, error } = materials;
  if (!stopCards.length) return null;
  const jobs = stopCards.filter(c => c.quotes.length).length;

  return (
    <Wrap>
      <Toggle type="button" onClick={() => setOpen(o => !o)}>
        <span className="l"><FaBoxes /> Total materials · {jobs} converted job{jobs === 1 ? '' : 's'}</span>
        <span className="r">{!loading && formatCurrency(grandTotal)} {open ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}</span>
      </Toggle>
      {open && (
        <div style={{ marginTop: 8 }}>
          {error && <Err>{error}</Err>}
          {loading ? <Muted>Loading quotes…</Muted> : summary.length === 0 ? <Muted>No approved quotes match the converted stops.</Muted> : summary.map(r => (
            <Row key={r.key}>
              <div>{r.name} <span className="qty">· {formatQty(r.qty)} {getUnitInfo(r.unit).short}</span></div>
              <div className="price">{formatCurrency(r.total)}</div>
            </Row>
          ))}
        </div>
      )}
    </Wrap>
  );
};

export default RouteMaterialsSummary;
